import { FaLock } from 'react-icons/fa';

export function LockIcon({ className }: { className?: string }) {
  return <FaLock className={`text-[0.8rem] ${className || ''}`} />;
}
